import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import { ICampaignAlterationRequestPayload } from "../types";

export function useCreateCostAdjustmentRequest(briefId?: string, onSuccessCallback?: () => void) {
  const {
    mutate: createCostAdjustment,
    isLoading: isCreating,
    isSuccess: isCreated,
    error,
  } = useMutation({
    mutationFn: (payload: ICampaignAlterationRequestPayload) =>
      CampaignService.createAlterationRequest(payload).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg || "Failed to create cost adjustment request");
        throw err;
      }),
    options: {},
    onSuccess: () => {
      ToastService.success("Cost adjustment request created successfully");
      onSuccessCallback?.();
    },
  });

  return {
    createCostAdjustment,
    isCreating,
    isCreated,
    error,
  };
}
